import React, { useEffect, useMemo, useState } from 'react';
import { DeviceFull } from '../../../hooks/useGetCurrentUserDevices.js';
import GeocoderService from '../../../services/GeocoderService.js';
import TileV2 from '../../bits/TileV2.tsx';
import TileActionRowLink from '../../bits/TileActionRowLink.jsx';
import { formatTimeFromNow } from '../../../services/DeviceUtils.js';

interface DeviceViewLivePanelProps {
  device: DeviceFull;
  disabled?: boolean;
};

/* Singleton. */
const geocoderService = new GeocoderService();

export const DeviceViewLivePanel: React.FC<DeviceViewLivePanelProps> = ({ device, disabled = false }) => {
  const [deviceAddress, setDeviceAddress] = useState<string>('');
  
  useEffect(() => {
    const { latitude, longitude } = device.lastPosition || {};

    if (!latitude || !longitude) {
      setDeviceAddress('');
      return;
    }

    geocoderService.reverseGeocodeWithCache(latitude, longitude).then((result: any) => {
      setDeviceAddress(result?.address || '');
    });
  }, [device.lastPosition?.latitude, device.lastPosition?.longitude]);


  const lastPositionedTimeDescription = useMemo(() => {
    if (!device.lastPosition?.position_at) {
      return '';
    }

    const desc = formatTimeFromNow(device.lastPosition.position_at);

    return desc ? `Last positioned ${desc}` : '';

  }, [device.lastPosition]);

  return (
    <TileV2 title="Location" subtitle={lastPositionedTimeDescription} disabled={disabled}>
      <TileActionRowLink
        description={deviceAddress || 'Unknown'}
        to={`/home?selectedDevice=${device.id}&mode=live`}
      />
    </TileV2>
  );
};
